// Copyright (c) Mysten Labs, Inc.
// Modifications Copyright (c) 2024 IOTA Stiftung
// SPDX-License-Identifier: Apache-2.0

export const FOOTER_LINKS = [
    { title: 'Youtube', href: 'https://www.youtube.com/c/iotafoundation' },
    { title: 'Github', href: 'https://github.com/iotaledger' },
    { title: 'Discord', href: 'https://discord.iota.org/' },
    {
        title: 'Twitter',
        href: 'https://twitter.com/iota',
    },
    {
        title: 'Reddit',
        href: 'https://www.reddit.com/r/Iota/',
    },
    {
        title: 'LinkedIn',
        href: 'https://www.linkedin.com/company/iotafoundation/',
    },
    {
        title: 'Instagram',
        href: 'https://www.instagram.com/iotafoundation/',
    },
];

export const LEGAL_LINKS = [
    {
        title: 'Terms & Conditions',
        href: 'https://iota.org/terms-of-use',
    },
    {
        title: 'Privacy Policy',
        href: 'https://iota.org/privacy-policy',
    },
    {
        title: 'Cookie Policy',
        href: '/cookie-policy',
    },
];
